import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface price {
    id: number,
    glass_id: number,
    glass_work_id: number,
    price: string,
}

// Add material state
export interface editPricingState {
    prices: price[],
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialEditPricingState: editPricingState = {
    prices: [{ glass_id: 0, glass_work_id: 0, id: 0, price: "0" }],
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Users slice
export const editPricingSlice = createSlice({
    name: 'edit_pricing',
    initialState: initialEditPricingState,
    reducers: {
        init: state => initialEditPricingState,
        set: (state, { payload }: PayloadAction<price>) => {
            state.prices = [payload]
        },
        setPriceValue: (state, { payload }: PayloadAction<string>) => {
            state.prices[0].price = payload;
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsSuccess: (state, { payload }: PayloadAction<boolean>) => {
            state.isSuccess = payload
        },
        setIsOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.isOpen = payload
        },
    }
})